<template>
  <div class="swiper-card card-achievement">
    <transition-group
      name="fade-slide-bottom"
      tag="div"
      v-if="reveal"
      class="reveal-group"
      appear
    >
      <div :key="'lottie'">
        <Lottie ref="lottie" animation="reward" :relative="true" />
      </div>
      
      <h3 :key="'title-wrapper'">{{ slide.content.title }}</h3>
      <p :key="'byline-wrapper'">{{ slide.content.byline }}</p>

      <div v-if="slide.content.dial" :key="'dial'" class="achievements">
        <UserTrack :size="120" :focus="getDialFocus" />
      </div>

      <div v-else :key="'achievements'" class="achievements">
        <div
          class="achievement"
          v-for="(achievement, idx) in slide.content.topics"
          :key="`achievement-${idx}`"
        >
          <img v-if="achievement.img" :src="achievement.img" :alt="achievement.name" />
          <span class="title">{{ achievement.name }}</span>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
  import Lottie from '@/components/v5/Lottie.vue';
  import UserTrack from '@/components/v5/elements/UserTrack.vue';

  export default {
    data() {
      return {
        reveal: false
      }
    },

    props: {
      slide: {
        type: Object,
      },
    },

    components: {
      Lottie,
      UserTrack
    },

    mounted () {
      this.$watch('$route.params.stack', (slug) => {
        if (slug === this.slide.slug) {
          this.$emit('swiperUpdate');
          this.$emit('enableNextAction');
          setTimeout(() => {
            this.play();
          }, 500);
        }
      }, { immediate: true });
    },

    computed: {
      getFocus() {
        return this.$userEngine.dialFocus;
      },

      getDialFocus() {
        return ['time','topics','locales'].includes(this.getFocus) ? this.getFocus : null;
      },
    },

    methods: {
      play() {
        this.reveal = true;

        setTimeout(() => {
          this.$refs.lottie?.play();
        }, 50);
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/v5_stacks.scss';

  .card-achievement {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 70vh;
    padding: 0 1rem;
    text-align: center;

    h3 {
      font-family: 'Circular';
      font-weight: bold;
      font-size: 1.75rem;
      margin: 2rem 0 0.5rem 0;
    }

    p {
      font-family: 'Circular';
      font-size: 1.1rem;
    }

    .achievements {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 1rem;
      width: 100%;
      margin-top: 2rem;

      .achievement {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        padding: 1rem;
        border-radius: 15px;
        background: $neutral-100;
        color: $neutral-600;

        .darkmode & {
          background: $neutral-300;
          color: $neutral-600;
        }

        img {
          width: 1.5rem;
          height: 1.5rem;
          object-fit: cover;
          border-radius: 50px;
          margin-right: 0.75rem;
        }

        .title {
          font-family: 'Circular';
          font-weight: bold;
          font-size: 1rem;
        }
      }
    }
  }

  .reveal-group > *:nth-child(2) {
    transition-delay: 0.10s;
  }
  .reveal-group > *:nth-child(3) {
    transition-delay: 0.25s;
  }
  .reveal-group > *:nth-child(4) {
    transition-delay: 0.40s;
  }
</style>

<style lang="scss">
.fade-slide-bottom-enter-active {
  transition: all 0.5s ease;
}
.fade-slide-bottom-enter {
  opacity: 0;
  transform: translateY(50px);
}
.fade-slide-bottom-enter-to {
  opacity: 1;
  transform: translateY(0);
}
</style>